import React from 'react';

const WebDashboardMainContainer = ({
	maxWidth,
	maxHeight,
	rememberDragPointerOffset,
	clearDragPointerOffset,
	children,
}) => (
	<div
		id='web-dashboard-main-container'
		style={{
			width: maxWidth,
			height: maxHeight,
			minHeight: 0,
			flex: '1 1 auto',
			display: 'flex',
			alignItems: 'flex-start',
			gap: '8px',
			marginTop: '8px',
			overflowX: 'hidden',
			background: 'var(--web-dashboard-main-container-bg)',
			direction: 'ltr',
		}}
		onDragStartCapture={rememberDragPointerOffset}
		onDragEndCapture={clearDragPointerOffset}
	>
		{children}
	</div>
);

export default WebDashboardMainContainer;
